import { createRouter as createTanstackRouter } from '@tanstack/react-router';

import logger from '#/logger';
import { routeTree } from '#/routeTree.gen';

export function createRouter() {
  return createTanstackRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultOnCatch: (error, info) => {
      logger.error({ err: error }, 'Error in route', info.componentStack);
    },
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
